class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.setupHover();
  }

  // Desktop only: open the mega menu on hover and keep it open while the pointer
  // is over the menu item, the invisible bridge, OR the dropdown panel (all are
  // DOM descendants, so moving between them does not fire mouseleave). A short
  // close delay covers any edge case.
  setupHover() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    const summary = this.mainDetailsToggle.querySelector('summary');
    let closeTimer;
    const open = () => {
      clearTimeout(closeTimer);
      if (!this.mainDetailsToggle.open) {
        this.mainDetailsToggle.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }
    };
    const scheduleClose = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => this.close(), 250);
    };
    this.addEventListener('mouseenter', open);
    this.addEventListener('mouseleave', scheduleClose);
    // Hover now controls open/close, so don't let a click on the top-level item toggle it shut.
    if (summary) summary.addEventListener('click', (event) => event.preventDefault());
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
